<template>
  <div class="about">
    <landing />
  </div>
</template>

<script>
import Landing from '@/components/satellite/Landing.vue'
export default {
  components: {
    Landing,
  }
}
</script>

<style lang="scss" scoped>
.about {
  // margin: 0 auto;
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
